import { render, staticRenderFns } from "./Bcard.vue?vue&type=template&id=054595ae"
import script from "./Bcard.vue?vue&type=script&lang=js"
export * from "./Bcard.vue?vue&type=script&lang=js"
import style0 from "./Bcard.vue?vue&type=style&index=0&id=054595ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports